import store from '../store/index'
import router from '../router/index'
import { errorReceived } from './apointUtil'
import { LogData } from './service'

// Version 1.01

// export const API_HOST = window.location.host.substring(0, 9) === "localhost"
// ? "https://localhost:44396" //DEV - Live
// : "https://api.apoint.co.il" //prod - Live;
export const environment =
  window.location.host.includes('localhost:') ||
  window.location.host.substring(0, 10) === '10.11.171.'
    ? 'Development' //DEV - Live
    : 'Production' //prod - Live;

export const API_HOST =
  window.location.host.includes('localhost:') ||
  window.location.host.substring(0, 10) === '10.11.171.'
    ? 'https://apidev.apoint.co.il' //DEV - Live
    : 'https://api.apoint.co.il' //prod - Live;

export const API_HOST1 = 'https://localhost:44392'

// export const API_HOST = "https://localhost:44390"
// export const API_HOST = 'https://apidev.apoint.co.il'

export const FETCH_DEFAULT_TIMEOUT = 10 * 1000 //10 seconds
export const PROC_DEFAULT_TIMEOUT = 10 * 1000 //10 seconds
export const FETCH_DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
}

export const apiPType = {
  BigInt: 0,
  Binary: 1,
  Bit: 2,
  Char: 3,
  DateTime: 4,
  Decimal: 5,
  Float: 6,
  Image: 7,
  Int: 8,
  Money: 9,
  NChar: 10,
  NText: 11,
  NVarChar: 12,
  Real: 13,
  UniqueIdentifier: 14,
  SmallDateTime: 15,
  SmallInt: 16,
  SmallMoney: 17,
  Text: 18,
  Timestamp: 19,
  TinyInt: 20,
  VarBinary: 21,
  VarChar: 22,
  Variant: 23,
  Xml: 25,
  Udt: 29,
  Structured: 30,
  Date: 31,
  Time: 32,
  DateTime2: 33,
  DateTimeOffset: 34,
}

export function Nz(val, zeroValue) {
  if (typeof zeroValue === 'undefined')
    if (typeof val === 'string') {
      zeroValue = ''
    } else {
      zeroValue = 0
    }
  if (val === null || val === undefined) return zeroValue
  else return val
}

export function setSessionData(userName, userPswd, compGUID) {
  store.commit('api/setSessionData', {
    User: {
      userName: userName,
      pswd: userPswd,
    },
    compGUID,
  })
}

export function apiGetCompGUID(compID, WebPswd) {
  const raw = [
    apiParam('CompID', compID, apiPType.Int),
    apiParam('WebPswd', WebPswd),
  ]
  const controller = new AbortController()
  const options = {
    method: 'POST',
    headers: FETCH_DEFAULT_HEADERS,
    signal: controller.signal,
    body: JSON.stringify(raw),
    redirect: 'follow',
  }

  let timeoutID = setTimeout(() => {
    controller.abort
    //TODO: לטפל במקרים של ניתוק תקשורת
    throw { error: 'connection timeout' }
  }, FETCH_DEFAULT_TIMEOUT)

  // console.log(options);
  return fetch(API_HOST + '/dbActions/Login/GetCompGuid', options)
    .then((response) => response.text()) //get text is async
    .then((result) => {
      clearTimeout(timeoutID)
      //parse and clean extra api data
      // console.log('login\\GetCompGuid result: ', result)
      let res = JSON.parse(result)
      if (res.APIResponseCode === 0) {
        return res
      } else {
        // console.log("apiGetCompGUID", res);
        return ''
      }
      // console.log(`login\\load APIResponseText: ${responseText}`);
    })
    .catch((error) => {
      // console.log(`login\\GetCompGUID ${error}`);
      throw error
    })
  // console.log(`apiGetCompGUID: ${compID} ${webPswd}`)
  // return '05885E42-5A7B-4F21-A139-A33EE947F545'
}

export function apiParam(name, val, pType = 8 /* int */) {
  return {
    paramName: name,
    paramValue: val === undefined ? null : val,
    paramType: pType,
  }
}

// export async function apiGetSessionToken(compGUID, userName, userPswd) {
//   let raw = [
//     apiParam("CompID", compGUID, 16),
//     apiParam("UserName", userName),
//     apiParam("UserPswd", userPswd),
//   ];

//   const controller = new AbortController();
//   const options = {
//     method: "POST",
//     headers: FETCH_DEFAULT_HEADERS,
//     signal: controller.signal,
//     body: JSON.stringify(raw),
//     redirect: "follow",
//   };

//   // console.log(options);
//   let timeoutID = setTimeout(() => {
//     controller.abort;
//     //TODO: לטפל במקרים של ניתוק תקשורת
//     throw { error: "connection timeout" };
//   }, FETCH_DEFAULT_TIMEOUT);
//   // console.log(store)
//   store.commit("api/resetToken");
//   store.commit("api/setSessionData", {
//     userName,
//     userPswd,
//     compGUID,
//   });
//   try {
//     const response = await fetch(API_HOST + "/dbActions/Login/Auth", options);
//     const result = await response.text();
//     const response_1 = JSON.parse(result);
//     clearTimeout(timeoutID);
//     // console.log(response_1);
//     if (response_1.APIResponseCode === 0) {
//       let userObject = JSON.parse(response_1.APIResponseText);
//       // console.log("Login/Auth response: ", response_1);
//       store.commit("api/setSessionData", {
//         sessionToken: userObject.sessionToken,
//       });

//       return userObject.sessionToken;
//     } else {
//       // console.log("apiGetSessionToken failed", response_1);
//       return "";
//     }
//   } catch (error) {
//     console.log("apiGetSessionToken error: ", error);
//     throw error;
//   }
// }

// V 1.01
export function callProc(
  procName,
  procParams,
  timeout = PROC_DEFAULT_TIMEOUT,
  dbName,
  schemaName,
  commandTimeout
) {
  // console.log("callProc: ", procName, procParams, store.state.api.sessionToken);
  let options, timeoutID, raw, controller
  controller = new AbortController()
  timeoutID = setTimeout(() => {
    controller.abort
    //TODO: לטפל במקרים של ניתוק תקשורת
    throw { error: 'connection timeout' }
  }, timeout)

  function setOptions() {
    let sessionToken = store.state.api.sessionToken
    raw = [
      apiParam('sessionToken', sessionToken, 16),
      apiParam('procName', procName, 12),
    ]
    if (procParams != undefined) {
      //add missing @ to param name
      ;(procParams = procParams.map((item) =>
        item.paramName.substring(0, 1) === '@'
          ? item
          : {
              paramName: '@' + item.paramName,
              paramValue: item.paramValue,
              paramType: item.paramType,
            }
      )),
        raw.push({
          paramName: 'procParams',
          paramValue: JSON.stringify(procParams),
          paramType: 12,
        })
    }
    if (dbName != undefined) {
      raw.push(apiParam('dbName', dbName, 22))
    }
    if (schemaName != undefined) {
      raw.push(apiParam('schemaName', schemaName, 22))
    }
    if (commandTimeout != undefined) {
      raw.push(apiParam('commandTimeout', commandTimeout, 22))
    }
    // console.log(raw);
    options = {
      method: 'POST',
      headers: FETCH_DEFAULT_HEADERS,
      signal: controller.signal,
      body: JSON.stringify(raw),
      redirect: 'follow',
    }

    // console.log(options);
  }
  setOptions()

  function doFetch(timeCount) {
    return fetch(API_HOST + '/dbActions/callProc', options)
      .then((response) => response.text()) //get text is async
      .then((result) => {
        clearTimeout(timeoutID)
        //parse and clean extra api data
        let res = JSON.parse(result)
        // console.log(res);
        if (res.APIResponseCode == 0) {
          // console.log(`callProc APIResponseText: ${responseText}`);
          if (res.APIResponseText === '{}') return res.APIResponseCode
          else return res.APIResponseText
        } else {
          // console.log(raw);
          throw {
            errorCode: res.APIResponseCode,
            errorDescription: res.APIResponseDescription,
            responseText: res.APIResponseText,
          }
        }
      })
      .catch((error) => {
        if (error.errorCode == -1 || !store.state.api.sessionToken) {
          //sessionToken expired
          store.commit('api/resetToken')
          return apiGetSessionToken(
            store.state.api.compID,
            store.state.api.User.userName,
            store.state.api.User.pswd
          )
            .then((result) => {
              if (result != '') {
                store.commit('api/setSessionData', {
                  sessionToken: result,
                })
                if (timeCount == 1) {
                  setOptions()
                  return doFetch(2)
                } else {
                  store.commit('api/setSessionData', {
                    loggedIn: false,
                  })
                  router.push({ name: 'Login' })
                }
              }
            })
            .then((result) => {
              return result
            })
            .catch(() => {
              store.commit('api/setSessionData', {
                loggedIn: false,
              })
              router.push({ name: 'Login' })
            })
        }
        throw error
      })
  }

  return doFetch(1)
}

// V 1.01
export function dbFuncVal(
  funcName,
  funcParams,
  timeout = PROC_DEFAULT_TIMEOUT,
  dbName,
  schemaName
) {
  // console.log(
  //   "dbFuncVal: ",
  //   funcName,
  //   funcParams,
  //   store.state.api.sessionToken
  // );
  let options, timeoutID, raw, controller
  controller = new AbortController()

  timeoutID = setTimeout(() => {
    controller.abort
    //TODO: לטפל במקרים של ניתוק תקשורת
    throw { error: 'connection timeout' }
  }, timeout)

  function setOptions() {
    raw = [
      apiParam('sessionToken', store.state.api.sessionToken, 16),
      apiParam('funcName', funcName),
    ]
    if (funcParams != undefined) {
      //add missing @ to param name
      ;(funcParams = funcParams.map((item) =>
        item.paramName.substring(0, 1) === '@'
          ? item
          : {
              paramName: '@' + item.paramName,
              paramValue: item.paramValue,
              paramType: item.paramType,
            }
      )),
        raw.push({
          paramName: 'funcParams',
          paramValue: JSON.stringify(funcParams),
          paramType: 12,
        })
    }
    if (dbName != undefined) {
      raw.push(apiParam('dbName', dbName, 22))
    }
    if (schemaName != undefined) {
      raw.push(apiParam('schemaName', schemaName, 22))
    }
    // console.log(raw);
    options = {
      method: 'POST',
      headers: FETCH_DEFAULT_HEADERS,
      signal: controller.signal,
      body: JSON.stringify(raw),
      redirect: 'follow',
    }
    // console.log(options);
  }
  setOptions()

  function doFetch(timeCount) {
    return fetch(API_HOST + '/dbActions/dbFuncVal', options)
      .then((response) => response.text()) //get text is async
      .then((result) => {
        clearTimeout(timeoutID)
        //parse and clean extra api data
        let res = JSON.parse(result)
        // console.log(res);
        if (res.APIResponseCode == 0) {
          // console.log(`dbFuncVal APIResponseText: ${responseText}`);
          if (res.APIResponseText === '{}') return res.APIResponseCode
          else return res.APIResponseText
        } else {
          // console.log(raw);
          throw {
            errorCode: res.APIResponseCode,
            errorDescription: res.APIResponseDescription,
            responseText: res.APIResponseText,
          }
        }
      })
      .catch((error) => {
        // console.log(`dbFuncVal error: ${funcName}`, error);
        if (error.errorCode == -1 || !store.state.api.sessionToken) {
          //sessionToken expired
          store.commit('api/resetToken')
          return apiGetSessionToken(
            store.state.api.compID,
            store.state.api.User.userName,
            store.state.api.User.pswd
          )
            .then((result) => {
              if (result != '') {
                store.commit('api/setSessionData', {
                  sessionToken: result,
                })
                if (timeCount == 1) {
                  setOptions()
                  return doFetch(2)
                } else {
                  store.commit('api/setSessionData', {
                    loggedIn: false,
                  })
                  router.push({ name: 'Login' })
                }
              }
            })
            .then((result) => {
              return result
            })
            .catch(() => {
              store.commit('api/setSessionData', {
                loggedIn: false,
              })
              router.push({ name: 'Login' })
            })
        }
        throw error
      })
  }
  return doFetch(1)
}

export function getCompanyDetails(compID) {
  if (compID === undefined) {
    compID = store.state.api.compGUID
  }
  const raw = [apiParam('CompID', compID, 16)]
  const controller = new AbortController()
  const options = {
    method: 'POST',
    headers: FETCH_DEFAULT_HEADERS,
    signal: controller.signal,
    body: JSON.stringify(raw),
    redirect: 'follow',
  }

  let timeoutID = setTimeout(() => {
    controller.abort
    //TODO: לטפל במקרים של ניתוק תקשורת
    throw { error: 'connection timeout' }
  }, FETCH_DEFAULT_TIMEOUT)

  // console.log(options);
  return fetch(API_HOST + '/dbActions/Login/Load', options)
    .then((response) => response.text()) //get text is async
    .then((result) => {
      clearTimeout(timeoutID)
      //parse and clean extra api data
      // console.log(`login\\load result: ${result}`);
      let res = JSON.parse(result)
      if (res.APIResponseCode === 0) {
        return res.APIResponseText
      } else {
        //compID guid is wrong
        return ''
      }
      // console.log(`login\\load APIResponseText: ${responseText}`);
    })
    .catch((error) => {
      // console.log("login\\load", error);
      throw error
    })
}

export function encrypt(data, encryptionKey = '') {
  if (encryptionKey == '') {
    encryptionKey = store.state.api.encryptionKey
  }
  let enc = require('simple-encryptor')(encryptionKey) //ENC_KEY is usually compGUID
  return enc.encrypt(data)
}

export function decrypt(data, decryptionKey = '') {
  if (decryptionKey == '') {
    decryptionKey = store.state.api.encryptionKey
  }
  let enc = require('simple-encryptor')(decryptionKey) //ENC_KEY is usually compGUID
  return enc.decrypt(data)
}

// V 1.01
export function uploadB64(
  parentType,
  parentID,
  createdBy,
  srcFileName,
  base64String,
  orgID = 1,
  fileID = 0,
  timeout = PROC_DEFAULT_TIMEOUT
) {
  // console.log("callProc: ", procName, procParams, store.state.api.sessionToken);
  const raw = [
    apiParam('sessionToken', store.state.api.sessionToken, 16),
    apiParam('parentType', parentType, 8),
    apiParam('parentID', parentID, 8),
    apiParam('orgID', orgID, 8),
    apiParam('fileID', fileID, 8),
    apiParam('createdBy', createdBy, 8),
    apiParam('srcFileName', srcFileName, 12),
    apiParam('base64String', base64String, 12),
  ]

  // console.log(raw);
  const controller = new AbortController()
  const options = {
    method: 'POST',
    headers: FETCH_DEFAULT_HEADERS,
    signal: controller.signal,
    body: JSON.stringify(raw),
    redirect: 'follow',
  }
  let timeoutID = setTimeout(() => {
    controller.abort
    //TODO: לטפל במקרים של ניתוק תקשורת
    throw { error: 'connection timeout' }
  }, timeout)

  // console.log(options);
  return fetch(API_HOST + '/files/upload/B64', options)
    .then((response) => response.text()) //get text is async
    .then((result) => {
      clearTimeout(timeoutID)
      //parse and clean extra api data
      let res = JSON.parse(result)
      // console.log(res);
      if (res.APIResponseCode == 0) {
        //// console.log(`callProc APIResponseText: ${responseText}`);
        // console.log(
        //   "uploadB64",
        //   "ResponseCode",
        //   res.APIResponseCode,
        //   "ResponseText",
        //   res.APIResponseText
        // );
        // if (res.APIResponseText === "{}") return res.APIResponseCode;
        // else return res.APIResponseText;
        return true
      } else {
        // console.log(raw);
        throw {
          errorCode: res.APIResponseCode,
          errorDescription: res.APIResponseDescription,
          responseText: res.APIResponseText,
        }
      }
    })
    .catch((error) => {
      // console.log(`callProc error: ${procName}`, error);
      if (error.errorCode == -1) {
        //sessionToken expired
        store.commit('api/resetToken')
        //TODO: popup login page to re-login and get new token to continue current action
        //TODO: route to main login page with prev route info to return to after re-login
      }
      throw error
    })
}

// V 1.02
export function apiGetCustomerCompany(mobile) {
  const raw = [apiParam('mobile', mobile, 22)]
  const controller = new AbortController()
  const options = {
    method: 'POST',
    headers: FETCH_DEFAULT_HEADERS,
    signal: controller.signal,
    body: JSON.stringify(raw),
    redirect: 'follow',
  }

  let timeoutID = setTimeout(() => {
    controller.abort
    //TODO: לטפל במקרים של ניתוק תקשורת
    throw { error: 'connection timeout' }
  }, FETCH_DEFAULT_TIMEOUT)

  // console.log(options);
  return fetch(API_HOST + '/BuildApp/Login/EzhGlobalTenantLogin', options)
    .then((response) => response.text()) //get text is async
    .then((result) => {
      clearTimeout(timeoutID)
      //parse and clean extra api data
      // console.log(`login\\load result: ${result}`);
      let res = JSON.parse(result)
      if (res.APIResponseCode === 0) {
        return res.APIResponseText
      } else {
        //compID guid is wrong
        return ''
      }
      // console.log(`login\\load APIResponseText: ${responseText}`);
    })
    .catch((error) => {
      // console.log("login\\load", error);
      throw error
    })
}

export function apiGetCompGuidByBID(CompID, BID) {
  const raw = [apiParam('CompID', CompID, 8), apiParam('BID', BID, 8)]
  const controller = new AbortController()
  const options = {
    method: 'POST',
    headers: FETCH_DEFAULT_HEADERS,
    signal: controller.signal,
    body: JSON.stringify(raw),
    redirect: 'follow',
  }

  let timeoutID = setTimeout(() => {
    controller.abort
    //TODO: לטפל במקרים של ניתוק תקשורת
    throw { error: 'connection timeout' }
  }, FETCH_DEFAULT_TIMEOUT)

  // console.log(options);
  return fetch(API_HOST + '/BuildApp/Login/GetCompGuidByBID', options)
    .then((response) => response.text()) //get text is async
    .then((result) => {
      clearTimeout(timeoutID)
      //parse and clean extra api data
      // console.log(`login\\load result: ${result}`);
      let res = JSON.parse(result)
      if (res.APIResponseCode === 0) {
        return res.APIResponseText
      } else {
        //compID guid is wrong
        return ''
      }
      // console.log(`login\\load APIResponseText: ${responseText}`);
    })
    .catch((error) => {
      // console.log("login\\load", error);
      throw error
    })
}

export function apiSavePDF(CompGUID, WebPswd, html, filePath) {
  const raw = [
    apiParam('CompGuid', CompGUID, 14),
    apiParam('WebPswd', WebPswd, 12),
    apiParam('html', html, 12),
    apiParam('filePath', filePath, 12),
  ]
  const controller = new AbortController()
  const options = {
    method: 'POST',
    headers: FETCH_DEFAULT_HEADERS,
    signal: controller.signal,
    body: JSON.stringify(raw),
    redirect: 'follow',
  }

  let timeoutID = setTimeout(() => {
    controller.abort
    throw { error: 'connection timeout' }
  }, FETCH_DEFAULT_TIMEOUT)

  // console.log(options);
  return fetch(API_HOST + '/docs/Pdf/SaveFromHtml', options)
    .then((response) => response.text()) //get text is async
    .then((result) => {
      clearTimeout(timeoutID)
      let res = JSON.parse(result)
      // console.log(res);
      return res.APIResponseCode
    })
    .catch((error) => {
      throw error
    })
}

export async function SessionTokenGetData(SessionToken) {
  let raw = [apiParam('sessionToken', SessionToken, 16)]

  const controller = new AbortController()
  const options = {
    method: 'POST',
    headers: FETCH_DEFAULT_HEADERS,
    signal: controller.signal,
    body: JSON.stringify(raw),
    redirect: 'follow',
  }

  // console.log(options);
  let timeoutID = setTimeout(() => {
    controller.abort
    //TODO: לטפל במקרים של ניתוק תקשורת
    throw { error: 'connection timeout' }
  }, FETCH_DEFAULT_TIMEOUT)
  // console.log(store)
  try {
    clearTimeout(timeoutID)
    const responseSetData = await fetch(
      API_HOST + '/utils/sessionToken/GetData',
      options
    )
    const result = await responseSetData.text()
    // console.log(JSON.parse(JSON.parse(result).APIResponseText));
    store.commit(
      'api/setSessionData',
      JSON.parse(JSON.parse(result).APIResponseText)
    )
  } catch (error) {
    console.log('apiGetSessionToken error: ', error)
    throw error
  }
}

export function apiCallToPhone(from, to) {
  var raw = [apiParam('FromPhone', from, 22), apiParam('ToPhone', to, 22)]
  let sessionToken = store.state.api.sessionToken
  raw.push(apiParam('sessionToken', sessionToken, 16))
  const controller = new AbortController()
  const options = {
    method: 'POST',
    headers: FETCH_DEFAULT_HEADERS,
    signal: controller.signal,
    body: JSON.stringify(raw),
    redirect: 'follow',
  }

  let timeoutID = setTimeout(() => {
    controller.abort
    //TODO: לטפל במקרים של ניתוק תקשורת
    throw { error: 'connection timeout' }
  }, FETCH_DEFAULT_TIMEOUT)

  return fetch(API_HOST + '/voip/CallToPhone/SessionToken', options)
    .then((response) => response.text()) //get text is async
    .then((result) => {
      clearTimeout(timeoutID)
      let res = JSON.parse(result)
      if (res.APIResponseCode === 0) {
        return res.APIResponseText
      } else {
        return ''
      }
    })
    .catch((error) => {
      throw error
    })
}

export function getGlobalApi(varName, dbName) {
  const funcParams = [
    apiParam('varName', varName, apiPType.VarChar),
    apiParam('org_id', 0, apiPType.TinyInt),
    apiParam('user', 0, apiPType.SmallInt),
  ]
  return dbFuncVal('GetGlobalAPI', funcParams, undefined, dbName)
    .then((result) => {
      return JSON.parse(result).funcResult
    })
    .catch(() => {
      errorReceived('GetGlobalAPI')
    })
}

export function callProcFixedToken(
  procName,
  procParams,
  timeout = PROC_DEFAULT_TIMEOUT,
  dbName,
  schemaName,
  commandTimeout
) {
  // console.log("callProc: ", procName, procParams, store.state.api.sessionToken);
  let options, timeoutID, raw, controller
  controller = new AbortController()
  timeoutID = setTimeout(() => {
    controller.abort
    //TODO: לטפל במקרים של ניתוק תקשורת
    throw { error: 'connection timeout' }
  }, timeout)

  function setOptions() {
    let sessionToken = '45A7C9DA-5A97-4F20-81EF-58B486317F38'
    let userPswd = 'j&dgt%^86'
    raw = [
      apiParam('sessionToken', sessionToken, 16),
      apiParam('userPswd', userPswd, 12),
      apiParam('procName', procName, 12),
    ]
    if (procParams != undefined) {
      //add missing @ to param name
      ;(procParams = procParams.map((item) =>
        item.paramName.substring(0, 1) === '@'
          ? item
          : {
              paramName: '@' + item.paramName,
              paramValue: item.paramValue,
              paramType: item.paramType,
            }
      )),
        raw.push({
          paramName: 'procParams',
          paramValue: JSON.stringify(procParams),
          paramType: 12,
        })
    }
    if (dbName != undefined) {
      raw.push(apiParam('dbName', dbName, 22))
    }
    if (schemaName != undefined) {
      raw.push(apiParam('schemaName', schemaName, 22))
    }
    if (commandTimeout != undefined) {
      raw.push(apiParam('commandTimeout', commandTimeout, 22))
    }
    // console.log(raw);
    options = {
      method: 'POST',
      headers: FETCH_DEFAULT_HEADERS,
      signal: controller.signal,
      body: JSON.stringify(raw),
      redirect: 'follow',
    }

    // console.log(options);
  }
  setOptions()

  function doFetch(timeCount) {
    return fetch(API_HOST + '/dbActions/FixedToken/callProc', options)
      .then((response) => response.text()) //get text is async
      .then((result) => {
        clearTimeout(timeoutID)
        //parse and clean extra api data
        let res = JSON.parse(result)
        // console.log(res);
        if (res.APIResponseCode == 0) {
          // console.log(`callProc APIResponseText: ${responseText}`);
          if (res.APIResponseText === '{}') return res.APIResponseCode
          else return res.APIResponseText
        } else {
          // console.log(raw);
          throw {
            errorCode: res.APIResponseCode,
            errorDescription: res.APIResponseDescription,
            responseText: res.APIResponseText,
          }
        }
      })
      .catch((error) => {
        if (error.errorCode == -1 || !store.state.api.sessionToken) {
          //sessionToken expired
          store.commit('api/resetToken')
          return apiGetSessionToken(
            store.state.api.compID,
            store.state.api.User.userName,
            store.state.api.User.pswd
          )
            .then((result) => {
              if (result != '') {
                store.commit('api/setSessionData', {
                  sessionToken: result,
                })
                if (timeCount == 1) {
                  setOptions()
                  return doFetch(2)
                } else {
                  store.commit('api/setSessionData', {
                    loggedIn: false,
                  })
                  router.push({ name: 'Login' })
                }
              }
            })
            .then((result) => {
              return result
            })
            .catch(() => {
              store.commit('api/setSessionData', {
                loggedIn: false,
              })
              router.push({ name: 'Login' })
            })
        }
        throw error
      })
  }

  return doFetch(1)
}

export async function apiGetSessionToken(
  compID,
  userName,
  userPswd,
  AppName = 'Workers app'
) {
  let raw = [
    apiParam('CompID', compID, 16),
    apiParam('UserName', userName),
    apiParam('UserPswd', userPswd),
  ]

  const controller = new AbortController()
  const options = {
    method: 'POST',
    headers: FETCH_DEFAULT_HEADERS,
    signal: controller.signal,
    body: JSON.stringify(raw),
    redirect: 'follow',
  }

  // console.log(options);
  let timeoutID = setTimeout(() => {
    controller.abort
    //TODO: לטפל במקרים של ניתוק תקשורת
    throw { error: 'connection timeout' }
  }, FETCH_DEFAULT_TIMEOUT)
  // console.log(store)
  store.commit('api/resetToken')
  store.commit('api/setSessionData', {
    User: {
      userName: userName,
      pswd: userPswd,
    },
    compID,
  })
  try {
    const response = await fetch(
      API_HOST + '/dbActions/Login/AuthByCompID',
      options
    )
    const result = await response.text()
    const response_1 = JSON.parse(result)
    clearTimeout(timeoutID)
    // console.log(response_1);
    if (response_1.APIResponseCode === 0) {
      let userObject = JSON.parse(response_1.APIResponseText)
      // console.log("Login/Auth response: ", response_1);
      store.commit('api/setSessionData', {
        sessionToken: userObject.sessionToken,
      })

      const packageJson = require('../../package.json')
      LogData(`AppName: ${AppName}, Version: ${packageJson.version}`)
      return userObject.sessionToken
    } else {
      // console.log("apiGetSessionToken failed", response_1);
      return ''
    }
  } catch (error) {
    console.log('apiGetSessionToken error: ', error)
    throw error
  }
}
export function appUpdateRequired(AppName = 'WorkersApp') {
  let AppVer
  const packageJson = require('../../package.json')
  AppVer = packageJson.version
  //https://apidev.apoint.co.il/utils/AppData?AppName=tenantApp&AppVer=1.2.32
  const controller = new AbortController()
  const options = {
    method: 'GET',
    headers: FETCH_DEFAULT_HEADERS,
    signal: controller.signal,
    redirect: 'follow',
  }

  let timeoutID = setTimeout(() => {
    controller.abort
    //TODO: לטפל במקרים של ניתוק תקשורת
    throw { error: 'connection timeout' }
  }, FETCH_DEFAULT_TIMEOUT)

  return fetch(
    `${API_HOST}/utils/AppData?AppName=${AppName}&AppVer=${AppVer}`,
    options
  )
    .then((response) => response.text()) //get text is async
    .then((result) => {
      clearTimeout(timeoutID)
      let res = JSON.parse(result)
      if (res.APIResponseCode === 0) {
        return res.APIResponseText
      } else {
        throw { error: res.APIResponseText }
      }
    })
    .catch((error) => {
      throw error
    })
}
export function TranslateProblem(PID, toLang) {
  var raw = [apiParam('pid', PID, 22), apiParam('toLanguage', toLang, 22)]
  let sessionToken = store.state.api.sessionToken
  raw.push(apiParam('sessionToken', sessionToken, 16))

  const controller = new AbortController()
  const options = {
    method: 'POST',
    headers: FETCH_DEFAULT_HEADERS,
    signal: controller.signal,
    body: JSON.stringify(raw),
    redirect: 'follow',
  }

  let timeoutID = setTimeout(() => {
    controller.abort
    //TODO: לטפל במקרים של ניתוק תקשורת
    throw { error: 'connection timeout' }
  }, FETCH_DEFAULT_TIMEOUT)

  return fetch(API_HOST + '/BuildApp/TranslateProblem/SessionToken', options)
    .then((response) => response.text()) //get text is async
    .then((result) => {
      clearTimeout(timeoutID)
      let res = JSON.parse(result)

      return res
    })
    .catch((error) => {
      throw error
    })
}
